import React from 'react'
import ReactDOM from 'react-dom/client'
import { api, setClientInfo } from '@carrent/api'
import { startTelemetry } from '@carrent/core'
import App from './App.jsx'

import '@carrent/ui/styles/tokens.css'
import '@carrent/ui/styles/base.css'
import './styles/console.css'

setClientInfo({ app: 'console', version: __APP_VERSION__ })

// Сбор телеметрии. Уважает переключатель в настройках и никогда
// не влияет на работу приложения: ошибки внутри проглатываются.
startTelemetry(api)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
